import axios from "axios"

let API_NAME = process.env.VUE_APP_API_NAME;

export default {
  async getUsers(accessToken) {
	  let res = await axios.get(API_NAME + "/users", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
          });
          
    return res.data;
  },
  async saveUser(accessToken, data) {
    let res = await axios.post(API_NAME + "/users", data, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  
}